/**
 * Semantic Color Mappings
 * Maps raw palette colors to semantic purposes
 */

import { sbs, neutrals } from './palettes';

/**
 * Light mode semantic colors
 */
export const semanticLight = {
  // Backgrounds
  background: neutrals.white,
  foreground: sbs.grayscale[900],
  surface: neutrals.offWhite,
  surfaceAlt: '#F5F5F5',

  // Primary colors
  primary: sbs.blue[400],
  primaryForeground: neutrals.white,

  // Accent colors
  accent: sbs.magenta[500],
  accentForeground: neutrals.white,

  // Secondary colors
  secondary: sbs.grayscale[100],
  secondaryForeground: sbs.grayscale[900],

  // Muted colors
  muted: sbs.grayscale[50],
  mutedForeground: sbs.grayscale[500],

  // Border and input
  border: sbs.grayscale[100],
  input: sbs.grayscale[100],
  ring: sbs.blue[400],

  // Status colors
  destructive: '#EF4444',
  destructiveForeground: neutrals.white,
  success: sbs.emeraldIce[500],
  successForeground: neutrals.white,
  warning: sbs.sunshine[500],
  warningForeground: sbs.grayscale[900],

  // Component-specific
  card: neutrals.white,
  cardForeground: sbs.grayscale[900],
  popover: neutrals.white,
  popoverForeground: sbs.grayscale[900],
} as const;

/**
 * Dark mode semantic colors
 */
export const semanticDark = {
  // Backgrounds
  background: '#1A1A1A',
  foreground: '#FAFAFA',
  surface: '#262626',
  surfaceAlt: '#2E2E2E',

  // Primary colors
  primary: sbs.blue[400],
  primaryForeground: neutrals.white,

  // Accent colors
  accent: sbs.magenta[400],
  accentForeground: neutrals.white,

  // Secondary colors
  secondary: '#333333',
  secondaryForeground: '#FAFAFA',

  // Muted colors
  muted: '#333333',
  mutedForeground: '#A0A0A0',

  // Border and input
  border: '#404040',
  input: '#404040',
  ring: sbs.blue[400],

  // Status colors
  destructive: '#DC2626',
  destructiveForeground: neutrals.white,
  success: sbs.emeraldIce[400],
  successForeground: neutrals.white,
  warning: sbs.sunshine[400],
  warningForeground: sbs.grayscale[900],

  // Component-specific
  card: '#262626',
  cardForeground: '#FAFAFA',
  popover: '#262626',
  popoverForeground: '#FAFAFA',
} as const;

export type SemanticColors = typeof semanticLight;
